export default __webpack_public_path__ + "4bfde69b8ad06f314474234e66222544.png";